module.exports = __webpack_public_path__ + "static/media/undraw_social_share_algy@2x.5d96a43f.png";